'use strict';

angular.module('studies')
    .controller('StudiesTableController', ['AccountManager', 'StudiesManager', function(AccountManager, StudiesManager) {
        var vm = this;

        vm.ready = false;
        vm.studies = [];

        vm.$onInit = function() {
            vm.userCanCreateStudies = AccountManager.hasPermission('create studies');

            return StudiesManager.reload()
                .then(function() {
                    vm.studies = StudiesManager.getUserStudies();
                    vm.ready = true;
                });
        };
    }]);
